/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PutModelCredential } from './put-model-credential';


export interface PutModelSettingsRequest { 
    /**
     * Model provider (e.g. \"anthropic\", \"openai\").
     */
    provider: string;
    /**
     * Model id within the provider.
     */
    id: string;
    /**
     * Key source the program chose. \"platform\" runs on Convercus\'s models (Claude on Amazon Bedrock, EU regions only) under the flat monthly budget; \"dedicated\" on the same models and the same platform tier with the program\'s own optional monthly limit, and takes no key (`credentials` or `apiKey` with it is a 422); \"byok\" on the program\'s own stored keys, uncapped and never blocked — whatever the model, since a model may exist in both tiers. The mode, not the model, decides the key source. Dedicated may only be saved by a SUPER_ADMIN (403 otherwise); leaving it for byok or platform is open to a program manager. Omitted: the program\'s saved mode; for a program with no settings, inferred from the model\'s tier, platform first.
     */
    mode?: PutModelSettingsRequest.ModeEnum;
    /**
     * The program\'s provider credentials, at most one row per provider — a program with an OpenAI and an Anthropic key may run and pin models from both. A row carrying `apiKey` replaces that provider\'s stored key; a row without one keeps the stored key and updates only `baseUrl`. Providers not mentioned keep what they have. Each key is verified live against its endpoint before anything is written, so a bad key or an unreachable URL is a 422 and changes nothing. Customer keys only, in platform or byok mode: a non-empty list with `mode: \"dedicated\"` is a 422.
     */
    credentials?: Array<PutModelCredential>;
    /**
     * Deprecated — use `credentials`. The provider API key for this request\'s `provider`, stored as a customer-owned credential. Kept for clients written before multiple keys existed; rejected together with `credentials`, and rejected in dedicated mode, which takes no key.
     */
    apiKey?: string;
    /**
     * The program\'s monthly limit in US dollars — dedicated mode only (D8), 422 in any other mode. Set it and the budget bar and the send-time block apply exactly as they do to a platform program; leave it out and the program\'s spend is shown without a bar and is never blocked. Omit to keep the stored limit, send `null` to clear it.
     */
    monthlyLimitUsd?: number | null;
}
export namespace PutModelSettingsRequest {
    export type ModeEnum = 'platform' | 'dedicated' | 'byok';
    export const ModeEnum = {
        Platform: 'platform' as ModeEnum,
        Dedicated: 'dedicated' as ModeEnum,
        Byok: 'byok' as ModeEnum
    };
}


